import QuestionViewVerbal from "./QuestionViewVerbal";

export default class QuestionViewVerbalVolume extends QuestionViewVerbal{
	constructor(question) {
		super(question);
	}

	initInputField() {
		super.initInputField();
		const unitLabel = new PIXI.Text('cm³', {fontSize: 40, fontFamily: "BBC Reith Sans", fontWeight: "bold"});
		unitLabel.anchor.set(0, 0.5);
		unitLabel.resolution = 2;
		unitLabel.position.set(this._inputField.width * 0.5, 0);
		this._inputField.addChild(unitLabel);
	}
}